import { render, staticRenderFns } from "./DiskInput.vue?vue&type=template&id=013108a2"
import script from "./DiskInput.vue?vue&type=script&lang=js"
export * from "./DiskInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports